import { IUpdateRawQueryListApiModel, UpdateType } from '@models/Update.model';
import {
  UpdateStatusPriority,
  UpdateStatusType,
} from '@models/UpdateStatus.model';
import { api } from '@services';

interface ICreateNotification {
  subject: string;
  description: string;
  originalMessage: string;
  productsIds: string[];
  tagsIds: string[];
  manufacturersIds: string[];
  dataDate: Date;
  dueDate: Date;
  type: UpdateType;
  usType: UpdateStatusType;
  priority?: UpdateStatusPriority;
}

const postCreateUpdate = async (
  data: ICreateNotification,
): Promise<IUpdateRawQueryListApiModel> => {
  const { data: update } = await api.post<IUpdateRawQueryListApiModel>(
    `/updates`,
    { ...data, sourceOrigin: 'Studio' },
  );

  return update;
};

export { postCreateUpdate };
